module.exports = __webpack_public_path__ + "static/media/plate_with_rice.4dfe06ba.png";